import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {TechnicalDeviceElement} from '@models/technical-device-element';
import {ConclusionFormDataService} from '../../services/conclusion-form-data.service';

@Component({
    selector: 'app-conclusion-element-preview',
    templateUrl: './conclusion-element-preview.component.html',
    styleUrls: ['./conclusion-element-preview.component.scss']
})
export class ConclusionElementPreviewComponent implements OnInit {

    public element: TechnicalDeviceElement;

    constructor(
        private route: ActivatedRoute,
        private formService: ConclusionFormDataService,
    ) {
    }

    ngOnInit() {
        if (this.formService.technicalDeviceElement) {
            this.element = new TechnicalDeviceElement(this.formService.technicalDeviceElement);
        }
    }

}
